export default __webpack_public_path__ + "static/media/BMSVNCKH-05 BCTĐCNĐT.cd241870.docx";